import { createJotaiVuexFacadeForReact } from "common/vue/createJotaiVuexFacadeForReact";
import { jotaiStore } from "./canvaModule.atoms";
import canvaModule from "./canvaModule";

const canvaStore = createJotaiVuexFacadeForReact({
  jotaiStore,
  state: {},
  stateKey: "canvaState",
  modules: {
    canva: canvaModule
  }
});

export default canvaStore;
